/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type InspectionPayment = {
  id: number;
  inspectionReservationId: number;
  merchantTransactionNo: string;
  paymentKey: string;
  reservedAt: string;
  confirmedAt: string;
  failedAt: string;
  canceledAt: string;
  totalAmount: number;
  discountAmount: number;
  paymentAmount: number;
  status: InspectionPayment.status;
  failureReasonCode: InspectionPayment.failureReasonCode;
  failureReasonText: string;
};
export namespace InspectionPayment {
  export enum status {
    RESERVED = 'RESERVED',
    CONFIRMED = 'CONFIRMED',
    FAILED = 'FAILED',
    REFUNDED = 'REFUNDED',
  }
  export enum failureReasonCode {
    HMG_PAY = 'HMG_PAY',
    PUBLIC_SERVICE_API = 'PUBLIC_SERVICE_API',
    USER_STOP = 'USER_STOP',
  }
}

